/**
 * Potrivirea paginii curente cu lista de URL-uri excluse a app-ului
 * (apps.excluded_urls, servită prin /config). Pe o pagină exclusă widgetul
 * nu se afișează și - mai important - nu se capturează niciun snapshot
 * (garda din runAsk, sdk.ts), ca textul paginii să nu plece spre backend.
 *
 * Semantica unui pattern, gândită pe identitatea de pagină din page.ts
 * (pathname + hash, fără query):
 *   - `#...`  → se potrivește DOAR pe hash (SPA-uri cu hash-routing: `#/login`
 *               exclude `#/login` indiferent de pathname);
 *   - conține `#` mai încolo → se potrivește pe pathname+hash întreg;
 *   - fără `#` → se potrivește DOAR pe pathname (hash-ul curent e ignorat:
 *               `/login` exclude `/login#top`);
 *   - `*` oriunde → orice secvență de caractere (`/admin/*`, `#/settings/*`).
 * Potrivirea e altfel exactă, case-insensitive, cu slash-ul final ignorat
 * (`/login/` ≡ `/login`) - excluderea e o decizie de prezentare, nu de rutare,
 * deci iertăm diferențele pe care un om nu le percepe ca „alt URL".
 */

function normalize(s: string): string {
  const lower = s.toLowerCase();
  return lower.length > 1 && lower.endsWith("/") ? lower.slice(0, -1) : lower;
}

function matchesPattern(target: string, pattern: string): boolean {
  if (!pattern.includes("*")) return normalize(target) === normalize(pattern);
  const rx = normalize(pattern)
    .split("*")
    .map((part) => part.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join(".*");
  return new RegExp(`^${rx}$`).test(normalize(target));
}

/** `pagePath` e ce dă `currentPagePath()`: pathname + hash. */
export function isExcludedPath(pagePath: string, patterns: string[]): boolean {
  const hashIdx = pagePath.indexOf("#");
  const pathname = hashIdx === -1 ? pagePath : pagePath.slice(0, hashIdx);
  const hash = hashIdx === -1 ? "" : pagePath.slice(hashIdx);
  for (const raw of patterns) {
    const pattern = raw.trim();
    if (!pattern) continue;
    const target = pattern.startsWith("#") ? hash : pattern.includes("#") ? pagePath : pathname;
    if (target && matchesPattern(target, pattern)) return true;
  }
  return false;
}
